const translations = {
  "videos.title": "You're ahead of the game",
  "videos.subtitle": "Check out exclusive videos from our student-athletes, crafted just for you.",
}

export default translations;
